"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const style_1 = __importDefault(require("../style"));
const constants_1 = require("utils/constants");
const FilterTImePicker = ({ onChange }) => {
    const defaultItemSelected = {
        text: 'grid.filterEqOperator', operator: 'eq', viewText: 'Is Equal to'
    };
    const [operator, setOperator] = (0, react_1.useState)(defaultItemSelected);
    const onClick = (e) => {
        const val = constants_1.specialFilterOperator.date.find(x => x.viewText === e.item.text);
        if (val)
            setOperator(val);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'k-filtercell' }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_dateinputs_1.TimePicker, { format: 'HH:mm:ss', onChange: e => onChange(Object.assign(Object.assign({}, e), { value: e.target.value, operator: operator.operator })) }), (0, jsx_runtime_1.jsx)(kendo_react_buttons_1.DropDownButton, Object.assign({ style: style_1.default.timePickerButton, icon: 'filter', onItemClick: onClick }, { children: constants_1.specialFilterOperator.date.map(item => ((0, jsx_runtime_1.jsx)(kendo_react_buttons_1.DropDownButtonItem, { text: item.viewText, selected: item.operator === operator.operator }, Math.random()))) }))] })));
};
exports.default = FilterTImePicker;
